export default "__VITE_ASSET__CrieJ$1i__"